module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#group",
      toString: function () {
        return this.url;
      }
    }